export default class DataColumn {
    constructor(entity = null, isLocked = false, isDeletable = true) {
        var _a, _b, _c, _d, _e, _f;
        this._header = null;
        this._isLoading = false;
        this._isEditing = false;
        this._isLocked = false;
        this._isDeletable = true;
        this.entity = entity;
        this._isLocked = isLocked;
        this._isDeletable = isDeletable;
        if (arguments.length === 1) {
            this.isLocked = (_d = (_b = (_a = this.entity) === null || _a === void 0 ? void 0 : _a.is_locked) !== null && _b !== void 0 ? _b : (_c = this.entity) === null || _c === void 0 ? void 0 : _c.is_in_review) !== null && _d !== void 0 ? _d : false;
        }
        if (this.entity) {
            this._header = (_f = (_e = this.entity) === null || _e === void 0 ? void 0 : _e.header) !== null && _f !== void 0 ? _f : moment.utc(this.entity.date).format('DD. MMMM YYYY');
        }
    }
    get entity() {
        return this._entity;
    }
    set entity(value) {
        if (value) {
            this._type = value.constructor.name;
            this._entity = value;
            if (value.status === BudgetStatus.LOCKED) {
                this._isLocked = true;
            }
        }
        else {
            this._type = null;
            this._entity = null;
        }
    }
    get type() {
        return this._type;
    }
    get header() {
        var _a;
        if (this._header) {
            return this._header;
        }
        return ((_a = this.entity) === null || _a === void 0 ? void 0 : _a.header) || null;
    }
    set header(value) {
        this._header = value;
    }
    get isLoading() {
        return this._isLoading;
    }
    set isLoading(value) {
        this._isLoading = value;
    }
    get isEditing() {
        return this._isEditing;
    }
    set isEditing(value) {
        this._isEditing = value;
    }
    get isLocked() {
        return this._isLocked;
    }
    set isLocked(value) {
        this._isLocked = value;
    }
    get isDeletable() {
        return this._isDeletable;
    }
    set isDeletable(value) {
        this._isDeletable = value;
    }
}
